import React from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { showCountsInTooltip } from "../../../store/config";
import { ReportTypes } from "../../../store/reports";
import { useReportContext } from "../ReportProvider";
import { useTooltipContent } from "./useTooltipContent";
import { FormattedDateTimeRage } from "../../formattedDateTime/FormattedDateTime";

import "./BarChartTooltip.scss";

export const BarChartTooltip = ({ container, is24, duration, tz }) => {
  const { displayedReports } = useReportContext();
  const showCounts = useSelector(showCountsInTooltip);
  const tooltip = useTooltipContent(container);

  if (!tooltip) return null;

  const {
    activeSlice: time,
    activePayload: data,
    activeCoordinate: { x },
  } = tooltip;

  const isReportDisplayed = (key) => displayedReports.includes(key);
  const isBlocksDisplayed = isReportDisplayed("blocks");
  const isSSDisplayed = isReportDisplayed("ss");

  const areCountsDisplayed = showCounts && (isBlocksDisplayed || isSSDisplayed);

  return (
    <div
      className={"report__tooltip report-tooltip"}
      style={{ left: Math.ceil(x) }}
    >
      <FormattedDateTimeRage
        time={time}
        is24={is24}
        duration={duration}
        tz={tz}
      />
      {areCountsDisplayed && (
        <div className={"report-tooltip__counts"}>
          {isBlocksDisplayed && renderCountBlocks(data)}
          {isSSDisplayed && renderCountSSBlocks(data)}
        </div>
      )}
    </div>
  );
};

const renderCountBlocks = (data) =>
  renderCount(data[ReportTypes.Blocks], "blocked_activity");
const renderCountSSBlocks = (data) =>
  renderCount(data[ReportTypes.SS], "malware_and_phishing_blocked");

const renderCount = (count, translationKey) => {
  if (!count) return null;
  return (
    <div className={"count"}>
      <div className={"count__name"}>
        <FormattedMessage id={translationKey} />
        {":"}
      </div>
      <div className={"count__value"}>{count}</div>
    </div>
  );
};
